export default __webpack_public_path__ + "static/media/52f509aa5fe5e2e5ffb00565f48600b91637094363756.b191a74f.webp";